import * as React from 'react';
import { Permission, MeatballMenu, PromptConfirmationModal } from 'ui';
import { InputModalHost } from 'ui/common/prompt-confirmation/input-modal-host';
import { DefaultCopyOptions } from 'ui/tile/copy-options';
import styles from './tile.scss';

const enabledFeatures = [

  (props,key) => (<Permission key={key} requireAll="remove" permissions={props.enabledChildEntityOperations} isListElement={true}>
              <PromptConfirmationModal
                  title={props.textDelete}
                  description={props.textDeleteMessage}
                  continueText={props.textContinue}
                  cancelText={props.textCancel}
                  onContinue={props.onDelete}>
                <button type="button" className="dropdown-item">{props.textDelete}</button>
              </PromptConfirmationModal>
          </Permission>),

  (props,key) => (!props.disableCopy && 
                  <Permission key={key} requireAll="add,copy" permissions={props.enabledChildEntityOperations} isListElement={true}>
                    <InputModalHost {...props} onContinue={props.onCopyDocumentItem}>
                      { ({isOpen, onOpen, onContinue, onCancel}) => {
                        return (
                          <>
                            <button type="button" className="dropdown-item" onClick={onOpen}>{props.copyIterator.copy}</button>
                            {isOpen &&
                              <DefaultCopyOptions
                                {...props}
                                handleContinue={onContinue}
                                handleCancel={onCancel}
                                translate={props.copyIterator}/>}
                          </>
                        );
                      }}
                    </InputModalHost>
                </Permission>)
];

export const ContextMenu = (props) => {
  const featureMenuItems = enabledFeatures.map((f, key) => f(props, key));
  const showMeatballMenu = (
      (props?.enabledChildEntityOperations?.add && props?.enabledChildEntityOperations?.copy) || 
      props?.enabledChildEntityOperations?.remove
    ) || !!props?.extendedContextMenuOperations?.length;
  
  return showMeatballMenu ? (
    <div className={`${styles.tileDropdown} ${props.className ? props.className : ''}`}>
      <MeatballMenu>
        {featureMenuItems}

        {props.extendedContextMenuOperations &&
        props.extendedContextMenuOperations.map((operation, i) =>
            <button key={`button-${i}`} type="button" className="dropdown-item" onClick={operation.callback}>
              {operation.text}
            </button>
          )
        }
      </MeatballMenu>
    </div>
  ) : null;
};
